module.exports = __webpack_public_path__ + "img/zhaolaoshi.ac1828bd.png";